import AboutMe from "../../entities/About/ui/AboutMe/AboutMe";

const InformationPage = () => {
    return ( 
        <div>
            <AboutMe/>
        </div>
     );
}
 
export default InformationPage;